export default __webpack_public_path__ + "07c3313b24f7b1ca85ee99b4fa7db55e.ttf";